import * as React from "react";
import { connect } from "react-redux";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import * as types from "../../../constants/actionTypes";
import AmbulatoryCareVideoVisit from "./AmbulatoryCareVideoVisit";
import * as queryString from 'query-string';
import Video from 'twilio-video';
import Spinner from '../../common/spinner';
import TermsForShareLink from '../ambulatorycarevideovisit/TermsForShareLink';

class NonLoggedInVideoVisit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isJoinClicked: false,
            startVisit: false,
            showTerms: true,
            upgradeiOS: false
        };
        this.onJoinVisit = this.onJoinVisit.bind(this);
        this.acceptTerms = this.acceptTerms.bind(this);
        this.callBackForTermsStatus = this.callBackForTermsStatus.bind(this);
        this.callBackForSubmittedTerms = this.callBackForSubmittedTerms.bind(this);
        this.isMobile = Tools.isMobile();
        this.ios = Tools.isIos();
        const { os, osVersion } = Tools.getOSInfo();
        const isiOS = os && os === "iOS" && this.isMobile && osVersion && osVersion[0];
        this.isOS15Point1 = isiOS && osVersion[0] == 15 && osVersion[1] && osVersion[1] == 1;
        this.sharedLinkCode = null;
    }

    componentDidMount() {
        const { location } = this.props;
        const params = location ? queryString.parse(location.search) : null;
        this.sharedLinkCode = params.sharedLinkCode ? params.sharedLinkCode : null;
        if (this.sharedLinkCode) {
            this.props.getVideoVisitShareLinkTermsStatus(this.sharedLinkCode, this.callBackForTermsStatus)
        }
        if (this.isOS15Point1) {
            this.setState({ upgradeiOS: true });
        }
        logUI("MBHWeb.UI.NonLoggedInVideoVisit.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    onJoinVisit() {
        logUI("MBHWeb.UI.NonLoggedInVideoVisit.JoinVisit.Clicked", new Date(), Tools.getURLPath());
        this.setState({ isJoinClicked: true });
    }

    acceptTerms(acceptedTermList) {
        let termList = [];
        if (acceptedTermList) {
            for (let i = 0; i < acceptedTermList.length; i++) {
                termList.push({
                    termId: acceptedTermList[i].id,
                    versionId: acceptedTermList[i].versionId,
                    isAccepted: acceptedTermList[i].isAccepted
                });
            }
        }
        const termsAndConditionsObj = { termsAndConditions: termList };
        logUI("MBHWeb.UI.VideoVisit.TermsForShareLink.Accepted", new Date(), Tools.getURLPath(), { sharedLinkCode: this.sharedLinkCode, acceptedTermList });
        this.props.acceptTermsForVideoVisitShareLink(this.sharedLinkCode, termsAndConditionsObj, this.callBackForSubmittedTerms)
    }

    callBackForTermsStatus(response) {
        let showTerms = true;
        if (response) {
            showTerms = response && response.hasAccepted ? false : true
        }
        if (showTerms) {
            this.props.getVideoVisitShareLinkTerms(this.props.shareLinkTermsFeatureId, this.sharedLinkCode);
        }
        this.setState({ showTerms: showTerms });
    }

    callBackForSubmittedTerms(response) {
        this.setState({ startVisit: true, isJoinClicked: true });
    }

    render() {
        const { location, match, shareLinkTermsStatus, videoVisitShareLinkTerms, acceptVideoVisitShareLinkTerms } = this.props;
        const { isJoinClicked, showTerms, startVisit } = this.state;
        const params = location ? queryString.parse(location.search) : null;
        const roomId = match.params.roomId;
        const jwttoken = params && params.limbotoken ? params.limbotoken : null;
        const isSupportedBrowser = Video.isSupported && !this.isOS15Point1;
        const isWaitingForTerms = (shareLinkTermsStatus && shareLinkTermsStatus.isWaiting) || (videoVisitShareLinkTerms && videoVisitShareLinkTerms.isWaiting)
            || (acceptVideoVisitShareLinkTerms && acceptVideoVisitShareLinkTerms.isWaiting) ? true : false;

        return (
            <div className={"container-fluid nonloggedin-video-visit-container body-content logged-out-container twilio-video-container"}>
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className={"row body-header__logo"}>
                            <div className="col-12">
                                <img src="/images/mybswhlogo.png" className="img-fluid" alt="Baylor Scott & White Health logo" />
                            </div>
                        </div>
                        {
                            <div className="row">
                                <div className="col-12">
                                    {isWaitingForTerms ? <Spinner /> :
                                        <>
                                            {isSupportedBrowser && (showTerms && !startVisit && videoVisitShareLinkTerms && videoVisitShareLinkTerms.terms && videoVisitShareLinkTerms.terms.isSuccessful)
                                                ? <TermsForShareLink videoVisitShareLinkTerms={videoVisitShareLinkTerms.terms} acceptTerms={this.acceptTerms} />
                                                : (isSupportedBrowser && !isJoinClicked)
                                                    ? <><div className="row join-video-visit-container">
                                                        <div className="col-12">
                                                            <h1 className="step-heading step-heading-md">Let's begin your visit</h1>
                                                            <div className="row">
                                                                <div className="col-12 join-visit-button">
                                                                    <button className="btn btn-primary" onClick={this.onJoinVisit}>JOIN VISIT</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div></>
                                                    :
                                                    <AmbulatoryCareVideoVisit
                                                        roomId={roomId}
                                                        jwttoken={jwttoken}
                                                        isFromNonLogin
                                                        sharedLinkCode={this.sharedLinkCode}
                                                        resetJoinVisit={() => { this.setState({ isJoinClicked: false }); }}
                                                        needIOSUpgrade={this.isOS15Point1}
                                                    />
                                            }
                                        </>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        shareLinkTermsFeatureId: state.session.serverData ? state.session.serverData.shareLinkTermsFeatureId : "ShareLink_En",
        shareLinkTermsStatus: state.portal.shareLinkTermsStatus,
        videoVisitShareLinkTerms: state.portal.videoVisitShareLinkTerms,
        acceptVideoVisitShareLinkTerms: state.portal.acceptVideoVisitShareLinkTerms
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getVideoVisitShareLinkTermsStatus: (shareLinkCode, callback) => dispatch({ type: types.GET_TERMS_STATUS_FOR_VIDEO_VISIT_SHARELINK, shareLinkCode, callback: callback }),
        getVideoVisitShareLinkTerms: (featureId, shareLinkCode) => dispatch({ type: types.GET_TERMS_FOR_VIDEO_VISIT_SHARELINK, featureId, shareLinkCode }),
        acceptTermsForVideoVisitShareLink: (shareLinkCode, termsAndConditions, callback) => dispatch({ type: types.ACCEPT_TERMS_FOR_VIDEO_VISIT_SHARELINK, shareLinkCode, termsAndConditions, callback })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NonLoggedInVideoVisit);